import React, {useState} from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {IconButton} from "@mui/material";
import {Box, Colors, IconEdit, IconNewTab, IconTrash, ListItemIcon, Menu, Text} from "@bounce/shared/ui";
import {MenuItem} from "./MenuItem";

export type RowActionItem = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

type Props = {
  onEdit?: () => void;
  onDelete?: () => void;
  onOpenInNewTab?: () => void;
  extraActions?: RowActionItem[];
};

export const RowActions = ({onEdit, onDelete, onOpenInNewTab, extraActions}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const close = () => setAnchorEl(null);

  const runAction = (e: React.MouseEvent, fn?: () => void) => {
    e.stopPropagation();
    close();
    fn?.();
  };

  return (
    <Box onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{width: 36, height: 36, borderRadius: "8px", color: Colors.grey._700, "&:hover": {backgroundColor: Colors.tertiary._200}}}
      >
        <MoreVertIcon sx={{width: 20, height: 20}} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={close} onClick={(e) => e.stopPropagation()}>
        {onOpenInNewTab && (
          <MenuItem onClick={(e) => runAction(e, onOpenInNewTab)}>
            <ListItemIcon>
              <Box component={IconNewTab} sx={{width: 20, height: 20, "& path": {stroke: "currentColor"}}} />
            </ListItemIcon>
            <Text size={14}>Open in new tab</Text>
          </MenuItem>
        )}
        {onEdit && (
          <MenuItem onClick={(e) => runAction(e, onEdit)}>
            <ListItemIcon>
              <Box component={IconEdit} sx={{width: 20, height: 20}} />
            </ListItemIcon>
            <Text size={14}>Edit</Text>
          </MenuItem>
        )}
        {extraActions?.map((action) => (
          <MenuItem key={action.label} disabled={action.disabled} onClick={(e) => runAction(e, action.onClick)}>
            <ListItemIcon>{action.icon}</ListItemIcon>
            <Text size={14}>{action.label}</Text>
          </MenuItem>
        ))}
        {onDelete && (
          <MenuItem onClick={(e) => runAction(e, onDelete)}>
            <ListItemIcon>
              <IconTrash color="currentColor" width={20} height={20} />
            </ListItemIcon>
            <Text size={14} sx={{color: "inherit"}}>
              Delete
            </Text>
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};
